import {CLStore} from 'common/src/redux/store';
import {AgentName} from '../copilot.enums';
import {Agent} from '../copilot.types';
import {getAllSkills} from '../skills';
import skills__agent from '../utils/creators/skills__agent';

export default function copilotSkillsAgent(store: CLStore): Agent {
  return skills__agent({
    store,
    getSkills: getAllSkills,
    name: AgentName.Copilot,
    role: 'You are Copilot, an intelligent assistant in the Flight Control product.',
  });
}
